import { MainModel, ModelsData } from "./connectModalElement";
import { c98img1, modalpic, walletconnect } from "../../../../assets";
import { useWalletConnectClient } from "services/walletServices";
import environment from "environment";
import { Image } from "react-bootstrap";
import { CgCloseR } from "react-icons/cg";
const ConnectModal = ({ closeModel }) => {
  const { connect, connectWithInjected } = useWalletConnectClient();
  const handleWeb3MetaMask = async () => {
    console.log("CONNECT");
    connectWithInjected(environment.DEFAULT_CHAIN);
    closeModel();
  };

  const handleWeb3WalletConnect = async () => {
    connect(`eip155:${environment.DEFAULT_CHAIN}`);
    closeModel();
  };

  return (
    <MainModel>
      <ModelsData>
        <div className="main-div">
          <Image src={modalpic} className="modal-img" />
          <div className="content-div">
            <div className="icon" onClick={closeModel}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
              >
                <g filter="url(#filter0_b_168_263)">
                  <rect
                    width="23.0476"
                    height="22"
                    rx="5.06258"
                    fill="#F7C13A"
                  />
                  <rect
                    x="0.253129"
                    y="0.253129"
                    width="22.5414"
                    height="21.4937"
                    rx="4.80945"
                    stroke="url(#paint0_linear_168_263)"
                    stroke-width="0.506258"
                  />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.6492 12.3643L14.718 15.4296C14.8808 15.5922 15.1017 15.6836 15.332 15.6836C15.5623 15.6836 15.7831 15.5922 15.946 15.4296C16.1088 15.2669 16.2003 15.0463 16.2003 14.8163C16.2003 14.5863 16.1088 14.3657 15.946 14.203L12.876 11.1377L15.9454 8.07236C16.026 7.99182 16.0899 7.89622 16.1335 7.791C16.1771 7.68579 16.1995 7.57303 16.1995 7.45915C16.1995 7.34528 16.177 7.23253 16.1334 7.12733C16.0897 7.02214 16.0257 6.92656 15.9451 6.84606C15.8645 6.76556 15.7688 6.70171 15.6634 6.65816C15.5581 6.61461 15.4452 6.5922 15.3312 6.59223C15.2172 6.59226 15.1043 6.61471 14.999 6.65832C14.8937 6.70192 14.798 6.76581 14.7174 6.84635L11.6492 9.91167L8.58034 6.84635C8.50031 6.7635 8.40455 6.6974 8.29867 6.65191C8.19279 6.60642 8.07889 6.58245 7.96364 6.5814C7.84838 6.58034 7.73407 6.60223 7.62737 6.64577C7.52067 6.68932 7.42372 6.75365 7.34218 6.83502C7.26064 6.9164 7.19614 7.01317 7.15244 7.11971C7.10875 7.22625 7.08673 7.34041 7.08768 7.45554C7.08862 7.57066 7.11251 7.68445 7.15796 7.79025C7.2034 7.89606 7.26948 7.99176 7.35235 8.07179L10.4223 11.1377L7.35293 14.2036C7.27006 14.2836 7.20398 14.3793 7.15854 14.4851C7.11309 14.5909 7.0892 14.7047 7.08825 14.8198C7.08731 14.935 7.10932 15.0491 7.15302 15.1557C7.19672 15.2622 7.26122 15.359 7.34276 15.4403C7.4243 15.5217 7.52125 15.586 7.62795 15.6296C7.73465 15.6731 7.84896 15.695 7.96422 15.694C8.07947 15.6929 8.19337 15.6689 8.29925 15.6235C8.40513 15.578 8.50088 15.5119 8.58092 15.429L11.6492 12.3643Z"
                  fill="#331D01"
                />
                <defs>
                  <filter
                    id="filter0_b_168_263"
                    x="-17.5165"
                    y="-17.5165"
                    width="58.0807"
                    height="57.0331"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur
                      in="BackgroundImageFix"
                      stdDeviation="8.75827"
                    />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_168_263"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_168_263"
                      result="shape"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_168_263"
                    x1="11.5238"
                    y1="-2.33446e-07"
                    x2="2.65184"
                    y2="30.8771"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.33" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h1>
              Connect Wallet
              <br />
              (Desktop)
            </h1>
            <div className="img-wrapper">
              <div className="img-div">
                <Image src={c98img1} onClick={() => handleWeb3MetaMask()} />
                <h5 onClick={() => handleWeb3MetaMask()}>C98 Wallet</h5>
              </div>
              <div className="img-div">
                <Image
                  src={walletconnect}
                  onClick={() => {
                    handleWeb3WalletConnect();
                  }}
                />
                <h5
                  onClick={() => {
                    handleWeb3WalletConnect();
                  }}
                >
                  Wallet Connect
                </h5>
              </div>
            </div>
          </div>
        </div>
      </ModelsData>
    </MainModel>
  );
};

export default ConnectModal;
